import script from "./HrExpandableSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HrExpandableSection.vue?vue&type=script&setup=true&lang=js"

import "./HrExpandableSection.vue?vue&type=style&index=0&id=19c2e32a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c2e32a"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem});
